var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGdLogo = function SvgGdLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.84 38.83"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.98 22.3 5.35 11.98c-7.15 1.87-14.84-1.64-17.95-8.6-2.5-5.59-1.36-11.9 2.41-16.25L6.01 5.44a19.2 19.2 0 0 0-4.71 7.07c-1.86 4.83-1.72 10.09.39 14.82s5.94 8.35 10.78 10.2 10.12 1.72 14.86-.39c.48-.21.94-.44 1.39-.68l-7.06-15.8-3.69 1.64z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.38 1.3c-4.84-1.85-10.12-1.72-14.86.39-.77.34-1.51.73-2.22 1.16l7.01 15.7 3.7-1.64-5.4-12.1c7.4-2.44 15.62 1.08 18.86 8.33 2.65 5.92 1.2 12.65-3.12 17.02l1.74 3.9c2.41-2.06 4.28-4.71 5.45-7.75 1.86-4.83 1.72-10.09-.39-14.82s-5.92-8.34-10.77-10.2Z"
  })));
};
export default SvgGdLogo;